"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleHover = exports.getUseDropProps = exports.getUseDragSourceProps = void 0;
var _ = require("../..");
var handleHover = exports.handleHover = function handleHover(item, index, ref) {
  if (!ref.current) {
    return;
  }
  var dragIndex = item.index;
  var dropIndex = index;

  // Don't replace items with themselves
  if (dragIndex === dropIndex) {
    return;
  }
  // Return if screen presenter source
  if (item.sourceType === _.SCREEN_PRESENTER) return;
  item.index = dropIndex;
  return item;
};
var getDragDropType = function getDragDropType(source) {
  return source.type === _.SCREEN_PRESENTER ? _.ItemTypes.SCREEN_PRESENTER : _.ItemTypes.SOURCE;
};
var getUseDropProps = exports.getUseDropProps = function getUseDropProps(cb, ref, index, source) {
  return {
    accept: getDragDropType(source),
    canDrop: function canDrop() {
      return true;
    },
    hover: function hover(item) {
      return handleHover(item, index, ref);
    },
    collect: function collect(monitor) {
      return {
        isOver: !!monitor.isOver()
      };
    },
    drop: function drop(item) {
      return cb(item, index);
    }
  };
};
var getUseDragSourceProps = exports.getUseDragSourceProps = function getUseDragSourceProps(source, index) {
  return {
    type: getDragDropType(source),
    item: {
      id: source._id,
      index: index,
      sourceType: source.type
    },
    canDrag: !(source.type === _.SCREEN_PRESENTER),
    collect: function collect(monitor) {
      return {
        isDragging: !!monitor.isDragging()
      };
    }
  };
};